import { Component, OnDestroy, OnInit, ViewChild, HostListener, ElementRef} from '@angular/core';
import { DialogComponent, DialogService } from 'ngx-bootstrap-modal';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { CommonConst } from '../shared/const/common-const';
import { MessageInfoComponent } from '../shared/component/message-info/message-info.component';
import { MessageUtil } from '../shared/utility/message-util';
import { GaUtil } from '../shared/utility/ga-util';
import { RedirectUtil } from '../shared/utility/redirect-util';
import { ValidationUtil } from '../shared/utility/validation-util';
import { N202A06OutKiboshashumeirisutoData } from '../shared/webapi-data/n202a06-out-kiboshashumeirisuto-data';
import { N202MainData } from './n202-main-data';
import { N202SessionStorageKey } from './n202-session-storage-key';
import { N2025OutputData } from './n2025-output-data';
import { CommonStorageKey } from '../shared';
declare var $: any;

@Component({
  selector: 'app-n2025',
  templateUrl: './n2025.component.html',
  styleUrls: ['./n2025.component.css']
})
export class N2025Component extends DialogComponent<null, boolean> implements OnInit, OnDestroy {
  @ViewChild('cancelEr') cancelEr: ElementRef;
  elementId: any;
  elementId2: any;

  public mainData = new N202MainData();
  public outputData = new N2025OutputData();
  public detailData: N202A06OutKiboshashumeirisutoData[] = [];
  public detailCount: number;
  public selectFlg: boolean = false;

  constructor(dialogService: DialogService,
    private http: HttpClient,
    private router: Router,
    private messageInfo: MessageInfoComponent) {
    super(dialogService);
  }

  /**
   * 初期表示
   */
  ngOnInit() {
    // 背面の固定
    $('body').css('overflow-y', 'hidden'); // 強化テストNo245

    const mainData = sessionStorage.getItem(N202SessionStorageKey.N2021HatchuInfo);
    if (!ValidationUtil.isEmpty(mainData)) {
      this.mainData = JSON.parse(mainData);
      sessionStorage.setItem(N202SessionStorageKey.N2021HatchuInfo, '');
    }
    document.body.style.cursor = 'wait';
    this.mainData.uniqueId = sessionStorage.getItem(CommonStorageKey.UNIQUEID);
    this.http.post<N2025OutputData>('/InitialN2025', this.mainData).subscribe(result => {
      // 非稼働の場合、メンテナンス画面に遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        this.close();
        return;
      }
      this.outputData = result[0];
      if (this.outputData.rtnCode == CommonConst.C_RTN_CODE_OK) {
        this.detailData = this.outputData.apiOutData.kiboshashumeirisuto;
        this.detailCount = this.detailData.length;
        setTimeout(() => {
          document.getElementById('kiboshashumei0').focus();
        }, 10);
      } else {
        this.close(false);
        this.router.navigateByUrl('/ne01', { skipLocationChange: true });
      }
    }, error => this.router.navigateByUrl('/ne01', { skipLocationChange: true }), () => { document.body.style.cursor = 'default'; });
  }

  /**
   * 希望車種を選択
   * @param index
   */
  kiboshashumei(index) {
    this.selectFlg = true;
    // 希望車種名
    sessionStorage.setItem(N202SessionStorageKey.N2025KIBOSHASHUMEI, this.detailData[index].kiboshashumei);
    // 配送ルート
    sessionStorage.setItem(N202SessionStorageKey.N2025HAISORUTO, this.detailData[index].haisoruto);
    // 荷量管理車種
    sessionStorage.setItem(N202SessionStorageKey.N2025NIRYOKANRISHASHU, this.detailData[index].niryokanrishashu);
    // 閉じる
    this.close(true);
    setTimeout(() => {
      document.getElementById(this.elementId2).focus();
    }, 200);
   GaUtil.traceEvent_EachGroupCd('発注入力 希望車種名選択', '');
  }

  cancel() {
    this.close(false);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  ngOnDestroy() {
    // 背面の固定解除
    $('body').css('overflow-y', 'scroll'); // 強化テストNo245

    this.close(false);
    if (this.selectFlg) {
      setTimeout(() => {
        document.getElementById(this.elementId2).focus();
      }, 200);
    } else {
      setTimeout(() => {
        document.getElementById(this.elementId).focus();
      }, 200);
    }
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // Tabキーの場合
    if (event.keyCode == 9 && !event.shiftKey) { // 強化テストNo247
      // 選択ボタンにフォーカス設定
      if (document.activeElement.id == 'cancelEr' || document.activeElement.id == '') {
        document.getElementById('kiboshashumei0').focus();
        return false;
      }
    }
    // 十字キー(←↑)の場合
    if (event.keyCode == 37 || event.keyCode == 38 || (event.keyCode == 9 && event.shiftKey)) {　// 強化テストNo247
      if (document.activeElement.id == 'kiboshashumei0' || document.activeElement.id == '') {
        document.getElementById('cancelEr').focus();
      } else if (document.activeElement.id == 'cancelEr') {
        let id = 'kiboshashumei' + (this.detailCount - 1);
        document.getElementById(id).focus();
      } else {
        let id = 'kiboshashumei' + (parseInt(document.activeElement.id.substr(13, 1)) - 1);
        document.getElementById(id).focus();
      }
      return false;
    }
    // 十字キー(→↓)場合
    if (event.keyCode == 39 || event.keyCode == 40) {
      if (document.activeElement.id == 'cancelEr' || document.activeElement.id == '') {
        document.getElementById('kiboshashumei0').focus();
      } else if (document.activeElement.id.substr(13, 1) == (this.detailCount - 1).toString()) {
        document.getElementById('cancelEr').focus();
      } else {
        let id = 'kiboshashumei' + (parseInt(document.activeElement.id.substr(13, 1)) + 1);
        document.getElementById(id).focus();
      }
      return false;
    }
    // 強化テストNo247 start
    // ENTERキーの場合
    if (event.keyCode == 13) {
      if (document.activeElement.id == 'cancelEr') {
        this.cancel();
      }
      return false;
    }
    // 強化テストNo247 end
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/n202/n2025.component.ts